module.exports = __webpack_public_path__ + "static/media/gameboy.104b4f08.jpg";